import { createContext } from 'react'
import { ErrorOpen } from './useErrorProvider'

export default createContext({
  open: (props: ErrorOpen) => null,
})
